export const STATE_WAIT = 1;
export const STATE_SEND = 2;
export const STATE_PICK = 3;
export const STATE_NOT_WORK = 4;